const map = {
	"./clear-day.png": 335,
	"./clear-night.png": 155,
	"./cloudy.png": 121,
	"./fog.png": 145,
	"./hail.png": 191,
	"./partly-cloudy-day.png": 559,
	"./partly-cloudy-night.png": 923,
	"./rain-snow-showers-day.png": 220,
	"./rain-snow-showers-night.png": 248,
	"./rain-snow.png": 731,
	"./rain.png": 511,
	"./showers-day.png": 849,
	"./showers-night.png": 461,
	"./sleet.png": 620,
	"./snow-showers-day.png": 359,
	"./snow-showers-night.png": 107,
	"./snow.png": 376,
	"./thunder-rain.png": 736,
	"./thunder-showers-day.png": 688,
	"./thunder-showers-night.png": 348,
	"./thunder.png": 615,
	"./wind.png": 199
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 634;